import { throttle } from '../util/function';
const doPreventOverflow = (verticalAlign, expanded, buttonElement, contentElement) => {
    if (!buttonElement || !contentElement) {
        return;
    }
    // arbitrary, but must be bigger than any browser's scrollbar gutter width
    const extraOffset = 20;
    const contentRect = contentElement === null || contentElement === void 0 ? void 0 : contentElement.getBoundingClientRect();
    const buttonRect = buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.getBoundingClientRect();
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    const maxRight = windowWidth - extraOffset;
    const minLeft = extraOffset;
    let right;
    let left;
    if (verticalAlign === 'left') {
        right = buttonRect.x + contentRect.width;
        left = buttonRect.x;
    }
    else {
        right = buttonRect.x + buttonRect.width;
        left = buttonRect.x + buttonRect.width - contentRect.width;
    }
    if (expanded) {
        if (right > maxRight) {
            contentElement.style.transform = `translateX(${maxRight - right}px)`;
        }
        else if (left < minLeft) {
            contentElement.style.transform = `translateX(${-left + minLeft}px)`;
        }
        else {
            contentElement.style.transform = '';
        }
    }
    else {
        contentElement.style.transform = '';
    }
};
export const preventOverflow = throttle(doPreventOverflow, 50);
